module.exports = __webpack_public_path__ + "img/ai_resume.544b303c.svg";